function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1948(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 91.09,
    height: 74.59,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.431666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.545,
    y: 37.295,
    fontFamily: "Arial"
  }, "\n        Apache\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 74.59,
    width: 91.09,
    height: 76.53,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.6530000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.545,
    y: 112.855,
    fontFamily: "Arial"
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 151.12,
    width: 91.09,
    height: 82.4,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.733333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.545,
    y: 192.32,
    fontFamily: "Arial"
  }, "\n        Mohave\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 233.52,
    width: 91.09,
    height: 89.96,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.245
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.545,
    y: 278.5,
    fontFamily: "Arial"
  }, "\n        Greenlee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 323.48,
    width: 91.09,
    height: 102.87,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.181666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.545,
    y: 374.915,
    fontFamily: "Arial"
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 426.35,
    width: 91.09,
    height: 134.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.38625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.545,
    y: 493.81500000000005,
    fontFamily: "Arial"
  }, "\n        Coconino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 561.28,
    width: 91.09,
    height: 138.72,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.181666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.545,
    y: 630.64,
    fontFamily: "Arial"
  }, "\n        Navajo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.09,
    y: 0,
    width: 123.45,
    height: 131.97,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.815,
    y: 65.985,
    fontFamily: "Arial"
  }, "\n        Pinal\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.53,
    y: 0,
    width: 146.03,
    height: 131.97,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 32.9925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.545,
    y: 65.985,
    fontFamily: "Arial"
  }, "\n        Yuma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.57,
    y: 0,
    width: 152.34,
    height: 131.97,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 32.9925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 436.74,
    y: 65.985,
    fontFamily: "Arial"
  }, "\n        Gila\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512.91,
    y: 0,
    width: 187.09,
    height: 131.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.852857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 606.4549999999999,
    y: 65.985,
    fontFamily: "Arial"
  }, "\n        Yavapai\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.09,
    y: 131.97,
    width: 224.08,
    height: 128.07,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.295714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 203.13,
    y: 196.005,
    fontFamily: "Arial"
  }, "\n        Cochise\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.09,
    y: 260.04,
    width: 224.08,
    height: 439.96,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 56.02
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 203.13,
    y: 480.02,
    fontFamily: "Arial"
  }, "\n        Pima\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.16,
    y: 131.97,
    width: 384.84,
    height: 568.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 48.105
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 507.58000000000004,
    y: 415.985,
    fontFamily: "Arial"
  }, "\n        Maricopa\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1948);
export default __webpack_public_path__ + "static/media/1948.68d46579a1b44a0406b50023e26b5512.svg";
export { ForwardRef as ReactComponent };